import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

const Layout = ({ children, transparentNav = false }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar transparent={transparentNav} />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
